export type PageDetails = {
  itemsPerPage: number;
  pageNumber: number;
  fullList?: boolean;
};

export type SortOrders = {
  field?: string;
  asc?: boolean | null;
  text?: string;
};

export type ExcelFields = {
  field: string;
  enable: boolean;
  text: string;
};

export type ExcelTemplate = {
  id?: string;
  name: string;
  productType: ProductType;
  entryType: EntryType;
  fields: ExcelFields[];
  isDefault?: true;
};

export enum ProductType {
  pharm = 'pharm',
  substance = 'substance',
  feed = 'feed',
  gmProduct = 'gmProduct',
  gmo = 'gmo',
}

export enum EntryType {
  requests = 'requests',
  registry = 'registry',
  inactive = 'inactive',
}

export enum PharmaceuticalType {
  VACCINE = 'VACCINE',
  ANTIBIOTIC = 'ANTIBIOTIC',
  OTHER = 'OTHER',
}

export type PharmaceuticalTypeOption = {
  value: PharmaceuticalType;
  label: string;
};

export enum ProducerVendorTypes {
  NONE = 'NONE',
  DOMESTIC = 'DOMESTIC',
  FOREIGN = 'FOREIGN',
  OTHER = 'OTHER',
}

export type DefaultFindFnParams = {
  entryType?: EntryType;
  pageDetails: PageDetails;
  productType?: ProductType;
  sortOrders?: SortOrders[];
  fields?: ExcelFields[];
};

export type ExtendedQuery<T> = {
  extendedQuery?: T;
};

export type FindFnParams<T> = DefaultFindFnParams & ExtendedQuery<T>;

export type PaginationResponse<T> = {
  itemList: T[];
  pageNumber: number;
  lastPageNumber?: number;
  itemPerPage: number;
  itemCount: number;
  desirableResidue?: number;
  firstResultIndex?: number;
  pageItemCount?: number;
};

export type WidgetColor = 'green' | 'red' | 'blue' | 'yellow' | 'grey';
